import CLEAR_ERROR from './actionTypes';

const clearError = () => ({ type: CLEAR_ERROR });

export default clearError;



// WEBPACK FOOTER //
// ./src/actions/global/index.js